"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SequencerToggleContextProvider = SequencerToggleContextProvider;
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _RCSequencerManager = _interopRequireDefault(require("../utils/RCSequencer/RCSequencerManager"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SequencerToggleContext = /*#__PURE__*/(0, _react.createContext)({
  sequencerToggle: false,
  setSequencerToggle: () => {}
});
function SequencerToggleContextProvider(_ref) {
  let {
    children
  } = _ref;
  const [selectedSequencerToggle, setSelectedSequencerToggle] = (0, _react.useState)(false);
  _RCSequencerManager.default.isSequencerOn = selectedSequencerToggle;
  const selectSequencerToggleHandler = sequencerToggle => {
    setSelectedSequencerToggle(sequencerToggle);
  };
  const context = {
    sequencerToggle: selectedSequencerToggle,
    setSequencerToggle: selectSequencerToggleHandler
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SequencerToggleContext.Provider, {
    value: context,
    children: children
  });
}
var _default = exports.default = SequencerToggleContext;